import { TransactionItemStandard } from '@/types/transactions';
import { SVSummaryCard } from '../core';
import { SVSummaryCardItem } from '@/types/common';
import TransactionAmount from './TransactionAmount';
import { formatDateTimeFromUTC } from '@/utils/date';
import { useAuthUser } from '@/hooks/stores/useAuthUser';
import {
  getCheckDepositErrorReason,
  getTransactionDeliverySpeedFromTransferType,
} from '@/utils/transactions';

type StandardTransactionDetailsProps = {
  transactionDetails: TransactionItemStandard;
};

export default function StandardTransactionDetails({
  transactionDetails,
}: StandardTransactionDetailsProps) {
  const { isStaff } = useAuthUser();
  const {
    statusLabel,
    startedAt,
    canceledAt,
    settledAt,
    fromAccount,
    toAccount,
    id,
    transferType,
    note,
    description,
    instructions,
  } = transactionDetails;

  const items: SVSummaryCardItem[] = [
    {
      label: 'Amount',
      customContent: <TransactionAmount transaction={transactionDetails} />,
    },
    { label: 'Status', text: statusLabel },
    { label: 'Created At', text: formatDateTimeFromUTC(startedAt, true) },
    { label: 'Canceled At', text: formatDateTimeFromUTC(canceledAt, true) },
    { label: 'Settled At', text: formatDateTimeFromUTC(settledAt, true) },
    {
      label: 'Error Reason',
      text: isStaff
        ? getCheckDepositErrorReason(transactionDetails.errorReason)
        : '',
    },
    {
      label: 'From Account',
      text: fromAccount?.bankName || '',
    },
    {
      label: 'To Account',
      text: toAccount?.bankName || '',
    },
    { label: 'Transaction Id', text: id },
    {
      label: 'Delivery Speed',
      text: getTransactionDeliverySpeedFromTransferType(transferType),
    },
    { label: 'Note', text: note || '' },
    { label: 'Transaction Description', text: description },
    { label: 'Instructions', text: instructions || '' },
  ];

  return <SVSummaryCard label="Basic Info" items={items} />;
}
